import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CredentialPayload } from '@ca/core/models';
import { RepositoryService, UserNotificationService, UserWorkspaceService } from '@ca/core/services';
import * as FormUtils from '../../../../utils/form/form-utils';

@Component({
    selector: 'ca-git-credential',
    templateUrl: './git-credential.component.html',
    styleUrls: ['./git-credential.component.scss'],
})
export class GitCredentialComponent implements OnInit {
    updating: boolean = false;
    @Input() showCredentials: boolean = true;

    formGroup: UntypedFormGroup;

    get hasGitCredentials(): boolean {
        return this.userWorkspaceService.hasGitCredentials;
    }
    set hasGitCredentials(value: boolean) {
        this.userWorkspaceService.hasGitCredentials = value;
    }

    constructor(
        private formBuilder: UntypedFormBuilder,
        private userWorkspaceService: UserWorkspaceService,
        private userNotificationService: UserNotificationService,
        private repositoriesService: RepositoryService,
    ) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            username: [this.userWorkspaceService.gitName, Validators.required],
            password: ['', Validators.required],
        });
        this.userWorkspaceService.getGitCredentials$().subscribe(
            () => {
                const userName = this.formGroup.get('username') as UntypedFormControl;
                userName.setValue(this.userWorkspaceService.gitName);
            },
            (error: HttpErrorResponse) => {
                console.error('Failed to get git credential', error);
            },
        );
    }

    submitGitCredential(): void {
        if (FormUtils.isValidForm(this.formGroup)) {
            this.updating = true;
            const payload: CredentialPayload = {
                Username: this.formGroup.value.username,
                Password: this.formGroup.value.password,
            };

            this.repositoriesService.setCredential(payload).subscribe(
                () => {
                    this.updating = false;
                    this.userNotificationService.showSuccess('Git credentials ' + (this.hasGitCredentials ? 'updated' : 'created'));
                    this.hasGitCredentials = true;
                },
                (error: HttpErrorResponse) => {
                    console.error('Failed to submit git credential', error);

                    this.updating = false;
                },
            );
        }
    }
}
